import { IconDislike16, IconLike16, UIHeading4, UIHeading5, UIText1 } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './styles.css';
import { IFavoriteEntity, ELikeDislikeReaction } from '../../../types/favoriteEntity';

interface IClientCommentProps {
  clientReactions?: IFavoriteEntity['clientReactions'];
  isSearcherOrSub?: boolean;
}

export const ClientComment = ({ clientReactions, isSearcherOrSub }: IClientCommentProps) => {
  if (!clientReactions) {
    return null;
  }

  return (
    <div className={styles['container']}>
      <div className={styles['content']}>
        {clientReactions.likeDislikeReaction === ELikeDislikeReaction.Like && (
          <div className={styles['reaction']} data-testid="like_block">
            <IconLike16 color="success_100" />
            <UIHeading5 color="success_100">{isSearcherOrSub ? 'Нравится' : 'Нравится клиенту'}</UIHeading5>
          </div>
        )}
        {clientReactions.likeDislikeReaction === ELikeDislikeReaction.Dislike && (
          <div className={styles['reaction']} data-testid="dislike_block">
            <IconDislike16 color="error_100" />
            <UIHeading5 color="error_100">{isSearcherOrSub ? 'Не нравится' : 'Не нравится клиенту'}</UIHeading5>
          </div>
        )}
        {clientReactions.comment && (
          <div className={styles['comment']} data-testid="comment_block">
            <UIHeading4>{isSearcherOrSub ? 'Комментарий' : 'Комментарий клиента'}</UIHeading4>
            <UIText1>{clientReactions.comment}</UIText1>
          </div>
        )}
      </div>
    </div>
  );
};
